import React from "react";
import { omit } from "lodash";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

const styles = {
  label: {
    display: "inline-block",
    padding: "4px",
    paddingLeft: 0,
    marginRight: "20px",
    cursor: "pointer",
    fontSize: 14,
  },
  radio: {
    margin: "0 0 0 2px",
    width: "initial",
    height: "initial",
    marginRight: "8px",
    fontSize: 16,
  },
};

/**
 * Deprecated, use material for new code
 * */
export const RadioBasic: React.FC<{
  name: string;
  label?: string;
  value?: any;
  onChangeAction?: any;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  formData?: any;
  defaultChecked?: boolean
}> = (props) => {
  const newProps = omit(props, [
    "options",
    "formData",
    "onChangeAction",
    "onBlurAction",
    "persistTableName",
    "labelStyle",
    // style is handled via sx below
    "style",
  ]);
  const { onChangeAction = () => null } = props;
  return (
    <FormControlLabel
      style={{ ...styles.label, ...props.labelStyle }}
      control={
        <Radio
          sx={{ ...styles.radio, ...props.style }}
          name={props.name}
          defaultChecked={props.defaultChecked}
          onChange={onChangeAction.bind(null, props)}
          value={props.value}
          inputProps={{ id: `${props.name}-${props.label}` }}
          {...newProps}
        />
      }
      label={props.label}
    />
  );
};
